import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "filter-header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "filters" }
const _hoisted_4 = { class: "radio-group" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "search-div" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "svg-icon text-black",
  focusable: "false",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/frontend/dist/svg-icons/icons.svg#search" })
], -1 /* HOISTED */)
const _hoisted_8 = { class: "genres-div" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "All Genres", -1 /* HOISTED */)
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value", "innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "loading"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "spinner-border" }, null, -1 /* HOISTED */)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "vision-catalog-listing" }
const _hoisted_16 = { class: "container" }
const _hoisted_17 = { class: "mediaItem" }
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "media-title" }
const _hoisted_20 = { class: "media-year" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediatypes, (mediatype) => {
              return (_openBlock(), _createElementBlock("label", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMediaType) = $event)),
                  type: "radio",
                  value: mediatype.id,
                  name: "selectedMediaType"
                }, null, 8 /* PROPS */, _hoisted_5), [
                  [_vModelRadio, _ctx.selectedMediaType]
                ]),
                _createTextVNode(" " + _toDisplayString(mediatype.displayname), 1 /* TEXT */)
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchText) = $event)),
                class: "form-control",
                placeholder: "Search"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.searchText]
              ]),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedGenre) = $event)),
                class: "form-control form-select"
              }, [
                _hoisted_9,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genres, (genre) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: genre.name
                  }, _toDisplayString(genre.name), 9 /* TEXT, PROPS */, _hoisted_10))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.selectedGenre]
              ])
            ])
          ]),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedMediaType) = $event)),
            class: "form-control form-select d-md-none"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediatypes, (mediatype) => {
              return (_openBlock(), _createElementBlock("option", {
                value: mediatype.id,
                innerHTML: $options.formatTypeNameForMobile(mediatype)
              }, null, 8 /* PROPS */, _hoisted_11))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [_vModelSelect, _ctx.selectedMediaType]
          ])
        ])
      ])
    ]),
    (!_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredMedia, (mediaitem) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("img", {
              src: mediaitem.imageurl,
              alt: mediaitem.imagealttext
            }, null, 8 /* PROPS */, _hoisted_18),
            _createElementVNode("div", _hoisted_19, _toDisplayString(mediaitem.displayname), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_20, _toDisplayString(mediaitem.releasedateyear), 1 /* TEXT */)
          ]))
        }), 256 /* UNKEYED_FRAGMENT */)),
        _hoisted_21
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}